import { NgModule } from '@angular/core';

import { NotificationEffects } from './NotificationEffects';

@NgModule({
  providers: [NotificationEffects],
})
export class NotificationEffectsModule {}
